import { render } from "./_PanelAgreementsItem.vue?vue&type=template&id=60b280cb"
import script from "./_PanelAgreementsItem.vue?vue&type=script&lang=js"
export * from "./_PanelAgreementsItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__